<template>
  <div>
    <div class="text-nowrap" v-if="shipping.external_code">
      {{shipping.external_code | cleanentityprefix}}
      <a href="#" @click.prevent="copyToClipboard(shipping.external_code)" class="text-secondary" :title="$gettext('Copy to Clipboard')">
        <font-awesome-icon :icon="['far', 'copy']" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShippingsListItemExternalId',
  props: {
    shipping: {
      type: Object,
      required: true
    }
  }
}
</script>
